import { Row, Col, size } from '@everlywell/leaves';
import { GatsbyImage as Img } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { animated as A, useSpring, config } from 'react-spring';
import { generateKey } from 'utils/helpers';

import { useScrolledIntoViewOnce } from 'utils/hooks';

import { ContentWithImage } from 'utils/types';
import Container from '../Container';
import SectionTitle from '../SectionTitle';

import * as S from './styles';

export interface OutreachSectionProps {
  title: string;
  headline: string;
  subheadline: string;
  listOfContent: ContentWithImage[];
}

export const OutreachSection: React.FC<OutreachSectionProps> = ({
  title,
  headline,
  listOfContent,
  subheadline,
}) => {
  const [topSectionInView, setTopSectionInView] = useState(false);
  const [bottomSectionInView, setBottomSectionInView] = useState(false);

  const topSectionEl = useScrolledIntoViewOnce(() => {
    setTopSectionInView(true);
  });

  const bottomSectionEl = useScrolledIntoViewOnce(() => {
    setBottomSectionInView(true);
  });

  // triggered from scrolling into view
  const topSectionTransition = useSpring({
    opacity: topSectionInView ? 1 : 0,
    transform: topSectionInView ? 'translateY(0)' : `translateY(${size.xl3}px)`,
    config: config.slow,
  });

  // triggered from scrolling into view
  const bottomSectionTransition = useSpring({
    opacity: bottomSectionInView ? 1 : 0,
    transform: bottomSectionInView
      ? 'translateY(0)'
      : `translateY(${size.xl3}px)`,
    config: config.slow,
  });

  return (
    <Container>
      <div ref={topSectionEl}>
        <A.div style={topSectionTransition}>
          <Row center="xs">
            <Col xs={12} lg={10}>
              <SectionTitle text={title} />
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12} lg={10}>
              <S.SectionHeadline>{headline}</S.SectionHeadline>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12} lg={6}>
              <S.SectionSubheadline>{subheadline}</S.SectionSubheadline>
            </Col>
          </Row>
        </A.div>
      </div>
      <div ref={bottomSectionEl}>
        <A.div style={bottomSectionTransition}>
          <Row center="xs" around="lg">
            <Col xs={12}>
              <S.InfoBlockContainer>
                {listOfContent.length
                  ? listOfContent.map((content) => (
                      <S.InfoBlockWrapper key={generateKey()}>
                        <S.InfoBlock
                          title={content.heading}
                          image={
                            <Img
                              image={content.image.gatsbyImageData}
                              alt={content.image.description || ''}
                              style={{ width: '100%', height: '100%' }}
                            />
                          }
                          imageAlt={content.image.description || ''}
                          content={content.description?.description || ''}
                          cta={content.cta}
                          size="small"
                        />
                      </S.InfoBlockWrapper>
                    ))
                  : null}
              </S.InfoBlockContainer>
            </Col>
          </Row>
        </A.div>
      </div>
    </Container>
  );
};

export default OutreachSection;
